module.exports = __webpack_public_path__ + "img/about-i@3x.58e25550.png";